import _taggedTemplateLiteral from "/codebuild/output/src748241224/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: nowrap;\n  position: relative;\n  flex-direction: row-reverse;\n  flex: 0 1;\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from "styled-components";
export var TransitionContainer = styled.div(_templateObject());
export default TransitionContainer;